import { AfterViewInit, Component, OnInit } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment/environment.service';
declare const $: any;

@Component({
  selector: 'app-domii-followup-landing',
  templateUrl: './domii-lead-followup.component.html'
})
export class DomiiLeadFollowupComponent implements OnInit, AfterViewInit  {

 androidStoreUrl: string;
  iOSStoreUrl: string;

    constructor(
      private environmentService: EnvironmentService) { }

  ngOnInit(): void {
     this.androidStoreUrl = this.environmentService.getAndroidStoreUrl();
    this.iOSStoreUrl = this.environmentService.getiOSStoreUrl();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const btn = document.getElementById('openFollowUpBtn');
      if (btn) btn.click();
    }, 0);
  }

  openAppStore() {
    window.open(this.iOSStoreUrl);
  }

  openPlayStore() {
    window.open(this.androidStoreUrl);
  }
}
